import { ArrowUpRight } from "lucide-react";
import { SITE } from "@/lib/site";

// Shown wherever a visitor with seller-intent might land on the store:
// watch product pages (category "Wrist") and watch-related catalog searches.
export const WatchBuyerBanner = ({ testid = "watch-buyer-banner" }) => (
  <a
    href={SITE.watchBuyersUrl}
    target="_blank"
    rel="noopener noreferrer"
    data-testid={testid}
    className="group flex items-center justify-between gap-4 bg-[#1A1A1A] rounded-sm px-5 py-4 hover:bg-black transition-colors duration-300"
  >
    <span className="text-sm leading-relaxed text-neutral-300">
      <span className="text-[#E8CC6E] font-semibold">Have a Swiss watch to sell?</span>{" "}
      Get a top-dollar valuation at our sister site{" "}
      <span className="font-semibold text-white">{SITE.watchBuyersName}</span> — Rolex, Omega,
      Patek Philippe &amp; more, nationwide.
    </span>
    <ArrowUpRight size={18} strokeWidth={1.5} className="shrink-0 text-[#E8CC6E] group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition-transform duration-300" />
  </a>
);
